// HeaderNavigation.jsx

import React, { useContext, useState, useEffect } from "react";
import { Header, Box, Image, Avatar, DropButton, Button } from "grommet";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
// IMPORTANT: Make sure this is the correct import for your setup
import { jwtDecode } from "jwt-decode";

import API_URL from "../../config/config";
import { AuthContext } from "../../contexts/AuthContext";
import LogoutButton from "../LogoutButton";

export const HeaderNavigation = ({ quizStarted = false }) => {
  const { user, jwtToken } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const [userInitials, setUserInitials] = useState("");
  const [userid, setUserId] = useState("");
  const [jwtData, setJwtData] = useState("");

  // Track whether we are in manager view (toggle = "on")
  const [isManagerView, setIsManagerView] = useState(false);

  // Control the DropButton’s open state (avoid using 'open' because it’s a restricted global)
  const [dropOpen, setDropOpen] = useState(false);

  /**
   * 1) Determine whether the path includes "manager"
   *    -> if yes, we set isManagerView to true
   */
  useEffect(() => {
    if (location.pathname.toLowerCase().includes("manager")) {
      setIsManagerView(true);
    } else {
      setIsManagerView(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (jwtToken) {
      try {
        const decodedToken = jwtDecode(jwtToken);
        setJwtData(decodedToken);

        const userId =
          decodedToken.role === "manager"
            ? decodedToken.user_table_id
            : decodedToken.user_id;

        setUserId(userId);
        const fetchUserName = async () => {
          const response = await axios.get(
            `${API_URL}/user/getUserNameById/${userId}`,
          );
          const name = response.data.name;
          const initials = name
            .split(" ")
            .map((n) => n[0])
            .join("")
            .toUpperCase();
          setUserInitials(initials);
        };

        if (userId) {
          fetchUserName();
        }
      } catch (err) {
        console.error("Error decoding token:", err);
      }
    }
  }, [jwtToken]);

  const dropdownContent = (
    <Box pad="small" direction="column" gap="small">
      <Box align="center" justify="center">
        <Button
          label="Dashboard"
          onClick={() => navigate(`/admin/dashboard`)}
        />
        {/* <Button
          label="Self guided help"
          onClick={() =>
            navigate(isManagerView ? `/manager/contact` : `/contact`)
          }
        /> */}
      </Box>
      <Box
        border={{ color: "brand", size: "small" }}
      // margin={{ vertical: "small" }}
      />
      <Box align="center" justify="center">
        <LogoutButton />
      </Box>
    </Box>
  );
  return (
    <Header
      fill="horizontal"
      background="black"
      pad={{ vertical: "small", horizontal: "large" }}
      height="70px"
      style={{ position: "relative" }} // Ensure relative positioning for absolute elements
    >
      {/* LEFT: Logo */}
      <Box
        direction="row"
        align="center"
        gap="small"
      // onClick={() => navigate(`/dashboard/${userid}`)}
      >
        <a
          href="https://education.hpe.com/ww/en/training/index.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Image
            src="/hpe-logo.png"
            alt="App Logo"
            width="130px"
            height="55px"
          />
        </a>
      </Box>

      {/* ABSOLUTE POSITIONED RIGHT BOX */}
      {!quizStarted && ( // Only render if quizStarted is false
        <>
          <Box
            align="end"
            direction="row"
            gap="small"
            style={{
              position: "absolute",
              right: "40px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            {/* Avatar + DropButton */}
            {jwtToken && (
              <Box direction="row" width="auto" gap="small" align="center">
                <DropButton
                  dropAlign={{ top: "bottom", right: "right" }}
                  dropContent={dropdownContent}
                  open={dropOpen}
                  onOpen={() => setDropOpen(true)}
                  onClose={() => setDropOpen(false)}
                >
                  <Avatar background="brand" size="medium">
                    {userInitials || "?"}
                  </Avatar>
                </DropButton>
              </Box>
            )}
          </Box>
        </>
      )}

      {/* Confirmation Dialog */}
    </Header>
  );
};
